<template>
  <div class="field checkbox">
    <input
      :id="filterId(filter.id)"
      type="checkbox"
      name="fitlers[]"
      :value="filter.id"
      :checked="isChecked"
      @change="setFilterOption($event, filter)"
    >
    <label :for="filterId(filter.id)">
      {{ filter.title }}
      <span>({{ filter.count }})</span>
    </label>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'CheckboxFilter',

  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState([
      'activeFilters'
    ]),

    isChecked() {
      return this.activeFilters.find(f => f.id === this.filter.id)
    }
  },

  methods: {
    ...mapMutations([
      'setActiveFiltersOption'
    ]),

    setFilterOption(option, filter) {
      this.setActiveFiltersOption(filter)
    },

    filterId(id) {
      return `filter-${id}`
    }
  }
}
</script>
